var GH_MS = /^ms\b/i.test(document.documentElement.lang || '') || /^\/ms(\/|$)/.test(location.pathname); /* f 4 Nov 2026: /ms labels */
/* 19 Oct 2026: engraved (By Glee) products need the personalisation form on their product page.
   Giffy chat cards come with a direct "Add to cart" button, so for those products it is swapped for a
   "Personalise" link to the product page. Collection and related-product cards are handled in Liquid.
   22 Oct 2026: Garden to Bath sets get a "Choose options" link too (the buyer's picks go on the product page). */
(function () {
  if (window.ghPzGuard) return;
  window.ghPzGuard = true;

  var PERSONALISED = /\/products\/personalised-/;
  var CHOOSE_VENDORS = ['Garden 2 Bath', 'Garden to Bath']; // v42 vendor rename

  function guard(card) {
    var btn = card.querySelector('button.gh-ai__add');
    var view = card.querySelector('a.gh-ai__view');
    if (!btn || !view) return;
    var vendor = card.querySelector('.gh-ai__vendor');
    var label = '';
    if (PERSONALISED.test(view.getAttribute('href') || '')) label = GH_MS ? 'Peribadikan' : 'Personalise';
    else if (vendor && CHOOSE_VENDORS.indexOf(vendor.textContent.trim()) !== -1) label = GH_MS ? 'Pilih pilihan' : 'Choose options';
    if (!label) return;
    var link = document.createElement('a');
    link.className = 'gh-ai__add';
    link.href = view.getAttribute('href');
    link.textContent = label;
    btn.replaceWith(link);
  }

  function scan(root) {
    if (root.matches && root.matches('.gh-ai__card')) guard(root);
    if (root.querySelectorAll) root.querySelectorAll('.gh-ai__card').forEach(guard);
  }

  new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) { if (node.nodeType === 1) scan(node); });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  scan(document);
})();
